const sizeConfigs = {
  sidebar: {
    width: "240px",
 
  }
};

export default sizeConfigs;